const React = require("react");
const PropTypes = require("prop-types");

function ErrorMessageMedgo({ label, type = "" }) {
  return <p className={"medgo-error " + type}>{label}</p>;
}

ErrorMessageMedgo.propTypes = {};

module.exports = ErrorMessageMedgo;



// WEBPACK FOOTER //
// ./assets/react/views/primitive/ErrorMessageMedgo.primitive.js